import type { SearchResult } from '@/scopes/search/search/infrastructure/api/types'

import type { IconGlyph } from '@sunwebgroup/ui-components'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createSearchProductClickEvent } from '@/scopes/search/search/domain/analytics'
import { useSearchStore } from '@/scopes/search/search/infrastructure/store/useSearchStore'
import { ProductCard } from './ProductCard'

export interface AccommodationService {
  icon?: IconGlyph
  text: string
  key: string
}

export function Result(result: SearchResult) {
  const { filterSelection } = useSearchStore()
  const { sendEvent } = useAnalytics()

  const onClickHandler = () => {
    sendEvent(createSearchProductClickEvent(result))
  }

  return (
    <ProductCard
      result={result}
      participants={filterSelection?.Participants}
      onClick={onClickHandler}
    />
  )
}
